Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Figma", {
  enumerable: true,
  get: function get() {
    return _figma.Figma;
  }
});
var _figma = require("./figma");